module.exports = __webpack_public_path__ + "img/souldy-icon-3.e9728388.jpg";